var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M7.46055 8.37915L2.12305 4.22915L1.69336 3.89478L2.12461 4.23071V12.3745H13.8746V4.23071L8.53398 8.37915C8.38049 8.4984 8.19164 8.56314 7.99727 8.56314C7.80289 8.56314 7.61405 8.4984 7.46055 8.37915Z",
    fill: "#008A5D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M13.6919 3.10571L14.306 3.89477L13.8747 4.2307L14.3075 3.89477L13.6935 3.10571H13.6919Z",
    fill: "#008A5D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 2.5H1.5C1.22344 2.5 1 2.72344 1 3V13C1 13.2766 1.22344 13.5 1.5 13.5H14.5C14.7766 13.5 15 13.2766 15 13V3C15 2.72344 14.7766 2.5 14.5 2.5ZM13.0234 3.62656L8 7.53125L2.97656 3.62656H13.0234ZM13.875 4.23125V12.375H2.125V4.23125L1.69375 3.89531L2.12344 4.22969L7.46094 8.37969C7.61444 8.49894 7.80328 8.56367 7.99766 8.56367C8.19203 8.56367 8.38088 8.49894 8.53438 8.37969L13.875 4.23125L14.3062 3.89531L13.6922 3.10625H13.6938L14.3078 3.89531L13.875 4.23125Z",
    fill: "#008A5D"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.78669b174e8c72c64a259f36d50521c2.svg";
export { ForwardRef as ReactComponent };